module.exports = __webpack_public_path__ + "img/t2-3.71e90d6e.png";